import { Grid, Typography } from "@material-ui/core";
import { ArrowBack, ArrowForward } from "@material-ui/icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import Alpha from "../../../constants/Alpha";
import { setStates } from "../../../redux/states";
import { getSearchResults } from "../../search-results/network_requests";
import DetailCard from "./DetailCard";
import DetailCardMobile from "./DetailCardMobile";
import ScrollOval from "./ScrollOval";

export default function ScrollCards(props) {
  const { setISIN, ISIN, Company, setCompany } = props;
  const dispatch = useDispatch();
  const states = useSelector((state) => state.states.value);
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const isLargeDesktop = useSelector((state) => state.isLargeScreen.value);
  const [companies, setCompanies] = useState(
    states?.companies[states?.companies.length - 1]
      ? states?.companies[states?.companies.length - 1]
      : []
  );

  let { queryISIN, query } = useParams();

  const [isDecreased, setIsDecrease] = useState(false);

  const [index, setIndex] = useState(
    companies?.findIndex((company) => company.ISIN === queryISIN)
  );

  const history = useHistory();
  const ref = useRef();

  useEffect(() => {
    setCompanies(
      states?.companies[states?.companies.length - 1]
        ? states?.companies[states?.companies.length - 1]
        : []
    );
  }, [states?.companies]);

  useEffect(() => {
    const newIndex = companies?.findIndex(
      (company) => company.ISIN === queryISIN
    );
    setIndex(newIndex);
    setCompany(companies[newIndex]);
  }, [companies]);

  useEffect(() => {
    setCompany(companies[index]);
  }, [index]);

  useEffect(async () => {
    if (Company) {
      setISIN(Company?.ISIN);
    } else {
      const newISIN = states?.ISIN?.findIndex(
        (companyISIN) => companyISIN === ISIN
      );
      const nextISIN = states?.ISIN[isDecreased ? newISIN - 1 : newISIN + 1];
      setISIN(nextISIN);
      const data = await getSearchResults(
        nextISIN,
        {},
        null,
        1,
        states?.tabValue,
        ""
      );
      setCompany(data.companies?.length > 0 ? data.companies[0] : {});
      const data1 = await getSearchResults(
        nextISIN,
        {},
        data.Session_Object,
        1,
        states?.tabValue,
        ""
      );
      setCompany(data1.companies?.length > 0 ? data1.companies[0] : {});
    }
  }, [Company]);

  useEffect(() => {
    props.setCardWidth(
      ref?.current?.clientWidth ? ref?.current?.clientWidth : 0
    );
  }, [ref?.current?.clientWidth]);

  useEffect(async () => {
    const new_companies = states?.companies[states?.companies.length - 1]
      ? states?.companies[states?.companies.length - 1]
      : [];

    setCompanies(new_companies);
    const currentIndex_ = new_companies?.findIndex(
      (company) => company.ISIN === queryISIN
    );

    setIndex(currentIndex_);
    setISIN(new_companies[currentIndex_]?.ISIN);

    // setISIN(queryISIN);
  }, [queryISIN]);

  return (
    <Grid
      container
      style={{
        marginTop: isDesktopOrLaptop ? "41px" : "15px",
        paddingLeft: isDesktopOrLaptop ? "98px" : "12px",
        paddingRight: isDesktopOrLaptop ? "98px" : "16px",
      }}
      alignItems={isDesktopOrLaptop ? "" : "center"}
    >
      <Grid
        item
        xs={isDesktopOrLaptop ? "auto" : 6}
        style={{
          margin: isDesktopOrLaptop ? "0 83px 11px 0px" : "0",
          width: isDesktopOrLaptop ? "161px" : "auto",
        }}
      >
        <Typography
          style={{
            fontFamily: "Overpass",
            fontSize: isDesktopOrLaptop ? "16px" : "14px",
            fontWeight: "bold",
            color: "#16063b",
            cursor: "pointer",
          }}
          onClick={() => {
            if (states.companies.length > 1) {
              dispatch(
                setStates({
                  ...states,
                  companies: states.companies.slice(0, -1),
                })
              );

              history.goBack();
            } else {
              dispatch(
                setStates({
                  ...states,
                  companies: [[...companies]],
                })
              );
              history.push(`/search-results/${query}/${props.tabValue}`);
            }
          }}
        >
          {`< ${props.t("back_to_results")}`}
        </Typography>
      </Grid>
      {isDesktopOrLaptop ? null : (
        <Grid
          item
          xs={6}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "16px",
          }}
        >
          <Alpha t={props.t} />
        </Grid>
      )}
      <Grid
        item
        xs={isDesktopOrLaptop ? "auto" : 12}
        style={{
          display: isDesktopOrLaptop ? "flex" : "",
        }}
        innerRef={ref}
      >
        {isDesktopOrLaptop ? (
          <DetailCard
            Company={Company}
            tabValue={states?.tabValue ? states.tabValue : 1}
            t={props.t}
          />
        ) : (
          <DetailCardMobile
            Company={Company}
            tabValue={states?.tabValue ? states.tabValue : 1}
            t={props.t}
          />
        )}
        {isLargeDesktop ? (
          <div
            style={{
              margin: "0px 0 0 829px",
              position: "absolute",
            }}
          >
            <Alpha height="45px" width="174px" t={props.t} />
          </div>
        ) : null}
      </Grid>
      {isDesktopOrLaptop ? (
        <Grid
          style={{
            marginTop: "29px",
          }}
        >
          {states?.ISIN?.length > 0 && Company?.ISIN !== states?.ISIN[0] ? (
            <ScrollOval
              type="left"
              setIndex={setIndex}
              index={index}
              setIsDecrease={setIsDecrease}
            />
          ) : null}
          {states?.ISIN?.length > 0 &&
          Company?.ISIN !== states?.ISIN[states?.ISIN?.length - 1] ? (
            <ScrollOval
              type="right"
              setIndex={setIndex}
              index={index}
              setIsDecrease={setIsDecrease}
            />
          ) : null}
        </Grid>
      ) : (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          style={{
            marginTop: "15px",
          }}
        >
          {states?.ISIN?.length > 0 && Company?.ISIN !== states?.ISIN[0] ? (
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                marginRight: "21px",
                justifyContent: "center",
                alignItems: "center",
                cursor: index === 0 ? "unset" : "pointer",
                boxShadow: "0 0 9px 0 #00000028",
              }}
              onClick={() => {
                setIsDecrease(true);
                setIndex(index - 1);
              }}
            >
              <ArrowBack
                style={{
                  width: "15px",
                  height: "14px",
                  color: "#16063b",
                }}
              />
            </div>
          ) : null}
          <p
            style={{
              fontFamily: "Overpass",
              fontSize: "16px",
              color: "#808080",
              letterSpacing: "normal",
              margin: 0,
            }}
          >
            <span style={{ fontWeight: 800, color: "#0040ff" }}>
              {states?.ISIN?.findIndex((compISIN) => compISIN === ISIN) + 1}
            </span>
            /{states?.ISIN?.length}
          </p>
          {states?.ISIN?.length > 0 &&
          Company?.ISIN !== states?.ISIN[states?.ISIN?.length - 1] ? (
            <div
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                backgroundColor: "#fff",
                display: "flex",
                marginLeft: "21px",
                justifyContent: "center",
                alignItems: "center",
                cursor: index + 1 === companies?.length ? "unset" : "pointer",
                boxShadow: "0 0 9px 0 #00000028",
              }}
              onClick={() => {
                setIsDecrease(false);
                setIndex(index + 1);
              }}
            >
              <ArrowForward
                style={{
                  width: "15px",
                  height: "14px",
                  color: "#16063b",
                }}
              />
            </div>
          ) : null}
        </Grid>
      )}
    </Grid>
  );
}
